import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GetPaidService } from '@app/+payment/services/get-paid.service';

@Component({
  selector: 'vc-code-verification',
  templateUrl: './code-verification.component.html',
  styleUrls: ['./code-verification.component.scss']
})
export class CodeVerificationComponent implements OnInit {
  input = new FormControl('', [Validators.required]);

  error = false;
  newCodeIsSent = false;
  lang = 'en';

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private getPaidService: GetPaidService,
    public dialogRef: MatDialogRef<CodeVerificationComponent>
  ) {}

  ngOnInit() {
    this.lang = this.getPaidService.getUserLang();
  }

  onSubmit() {
    this.error = false;

    this.getPaidService.checkOTPCode('VC' + this.input.value).subscribe(
      _ => {
        this.getPaidService.getCustomer().subscribe({
          next: () => this.dialogRef.close({ success: true })
        });
      },
      _ => (this.error = true)
    );
  }

  sendNewCode() {
    this.getPaidService.sendNewVerificationCode().subscribe({
      next: () => {
        this.newCodeIsSent = true;
        // hide message after 8sec
        setTimeout(() => {
          this.newCodeIsSent = false;
        }, 8000);
      }
    });
  }
}
